export enum NotesEntryFormNamesEnum {
  FORM_GROUP_NAME = 'notesEntryForm',
  SUBJECT = 'subjectTxt',
  NOTE_TYPE = 'typeCd',
  CONTENT = 'noteTxt',
}
